
import { defineComponent } from "vue";
import { PaginatedTable, usePagination } from "@/components/common/tables";
import { PagedAsyncIterDriver } from "@/pagination";
import VueIFrame from "@/components/IFrame.vue";
import { videoService } from "@/services"; //
import { mdiPencil, mdiEye, mdiTrashCan } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import { SearchNewsRequestParams } from "@/services/news-service";

export default defineComponent({
  components: {
    PaginatedTable,
    SvgIcon,
    VueIFrame,
  },
  props: {
    triggerDataReload: {
      type: Boolean,
      required: false,
    },
  },
  setup(_, { emit }) {
    return { ...usePagination(emit, true) };
  },
  emits: ["loadingData"] as string[],
  data() {
    return {
      currentPage: 0,
      videoInputVal: "",
      tableColumnsConfig: [
        { title: "Titulo", propertyName: "title" },
        { title: "Descripción", propertyName: "description" },
        {
          title: "Vista previa",
          slotName: "preview",
          columnClasses: ["video-preview-column"],
          dataClasses: ["video-preview-container"],
        },
        {
          title: "Ver video",
          slotName: "actions",
          columnClasses: ["actions-column"],
        },
      ],
      mdiPencil,
      mdiTrashCan,
      mdiEye,
    };
  },
  watch: {
    triggerDataReload() {
      this.initData();
    },
    pageSize() {
      this.fetchData(this.currentPage);
    },
  },
  methods: {
    async onPaginationClick(payload: { pageClicked: number }) {
      await this.fetchData(payload.pageClicked);
      this.currentPage = payload.pageClicked;
    },
    async initData() {
      const params: SearchNewsRequestParams = {};
      params.status = "public";

      if (this.videoInputVal != "") {
        params.title = this.videoInputVal;
      }

      this.driver = new PagedAsyncIterDriver(videoService.getAllVideos(params));

      this.elements = [];

      await this.fetchData(1);
      this.currentPage = 1;
    },
  },
  async mounted() {
    await this.initData();
  },
});
